module.exports = __webpack_public_path__ + "static/media/sidemenu-close.829352bf.svg";